import React from "react";
import {Box,TextField} from "@mui/material";
import {useSelector,useDispatch} from "react-redux";
import {
searchTextFilter,
} from "../../store/Store";

function Search(){
	const dispatch = useDispatch();
	const searchText = useSelector((state)=>state.App.initialAppData.searchText);
	const searchFilterValue = useSelector((state)=>state.API.searchText);

	function filterByValue(e){
		dispatch(searchTextFilter(e.target.value));
	}

	return (
		<Box className="search_class">
			<TextField label={searchText}
					   variant="filled"
					   size="small"
					   color="success"
					   value={searchFilterValue}
					   onChange={filterByValue}
					   />
		</Box>
	);
}

export default Search;